import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";
import Albums from "@components/Home/AlbumRoutes/Albums/Albums";
import EditAlbumPage from "@components/Home/AlbumRoutes/EditAlbum/EditAlbumPage";

const AlbumRoutes: FC = () => {
  return (
    <Routes>
      <Route path="" element={<Albums />} />
      <Route path="/new" element={<EditAlbumPage />} />
      <Route path="/:id" element={<EditAlbumPage />} />
      <Route path="*" element={<Albums />} />
    </Routes>
  );
};

export default AlbumRoutes;
